import React, { useEffect, useState, useContext } from 'react';
import { Bar, Pie } from 'react-chartjs-2';
import { getCount } from '../../api/Api';
import { AuthContext } from '../../utils/AuthContext';
import { generateAcademicYears } from '../../utils/academicYearUtils';
import { faChevronDown, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import {
  UserPlusIcon,
  CheckCircleIcon,
  AcademicCapIcon,
  CurrencyRupeeIcon,
  ChartBarIcon
} from '@heroicons/react/24/outline';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const Dashboard = () => {
  const [counts, setCounts] = useState({
    students: 0,
    forms: 0,
    approvedForms: 0,
    totalCollectedFees: 0,
    overallFeeAmount: 0,
    BalanceAmount: 0,
    totalExpansiveAmount: 0,
    miscBillTotal: 0,
    totalPaidWithMisc: 0,
  });
  console.log(counts)

  const { academicYear, setAcademicYear } = useContext(AuthContext);
  const academicYears = generateAcademicYears();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCount(academicYear);
        if (response.success) {
          setCounts(response.data);
          console.log(response.data)
        }
      } catch (error) {
        console.error('Error fetching counts:', error);
      }
    };
    fetchData();
  }, [academicYear]);

  // Bar Chart Data
  const chartData = {
    labels: ['Enquiry', 'Approved Admission'],
    datasets: [
      {
        label: 'Counts',
        data: [counts.students, counts.approvedForms],
        backgroundColor: ['#dbac38', '#16bab1'],
        borderRadius: 10,
        barThickness: 50,
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { color: '#6B7280', stepSize: 1 },
        grid: { color: '#E5E7EB' }
      },
      x: {
        ticks: { color: '#6B7280' },
        grid: { display: false }
      }
    }
  };
  const feeChartData = {
    labels: ['Collected Fees', 'Pending Fees'],
    datasets: [
      {
        label: 'Fee Distribution',
        data: [
          counts.totalCollectedFees,
          Math.max(counts.overallFeeAmount - counts.totalCollectedFees, 0)
        ],
        backgroundColor: ['#16bab1', '#f36743'],
        hoverOffset: 10,
        borderColor: '#ffffff',
        borderWidth: 2,
      }
    ]
  };
 
  
  const ExpanChartData = {
    labels: ['Income', 'Expenses'],
    datasets: [
      {
        label: 'Profit & Loss',
        data: [
          counts.totalPaidWithMisc,
          counts.totalExpansiveAmount
        ],
        backgroundColor: ['#A8DF8E', '#f36743'],
        hoverOffset: 10,
        borderColor: '#ffffff',
        borderWidth: 2,
      }
    ]
  };
  
  const pieOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          color: '#374151',
          font: { size: 14, weight: 'bold' }
        }
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.label || '';
            const value = context.parsed;
            return `${label}: ₹${value.toLocaleString()}`;
          }
        }
      }
    }
  };
  
  const expanpieOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          color: '#374151',
          font: { size: 14, weight: 'bold' }
        }
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.label || '';
            const value = context.parsed;
            return `${label}: ₹${value.toLocaleString()}`;
          }
        }
      }
    }
  };
  

  return (
    <div className="max-w-screen-xl mx-auto h-screen p-4">
      {/* Dashboard Header with Filter */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-8 gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Dashboard Overview</h1>
          <p className="text-sm text-gray-500">Real-time school performance metrics</p>
        </div>

        <div className="flex items-center gap-3 bg-white p-2 rounded-xl shadow-sm border border-gray-100">
          <div className="bg-[#16bab1]/10 p-2 rounded-lg">
            <FontAwesomeIcon icon={faCalendarAlt} className="text-[#16bab1] w-4 h-4" />
          </div>
          <div className="flex flex-col">
            <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">Academic Year</label>
            <div className="relative flex items-center">
              <select
                value={academicYear}
                onChange={(e) => setAcademicYear(e.target.value)}
                className="text-sm font-semibold text-gray-700 bg-transparent outline-none pr-6 appearance-none cursor-pointer"
              >
                <option value="">Overall View</option>
                {academicYears.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
              <FontAwesomeIcon icon={faChevronDown} className="absolute right-0 text-gray-400 w-2.5 h-2.5 pointer-events-none" />
            </div>
          </div>
        </div>
      </div>

      {/* Cards Section */}
    
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-2">
      <h1 className='  text-gray-500 text-md  text-center border rounded-2xl bg-white p-2 flex flex-col justify-center'>

Admission Management
</h1>
        <InfoCard title="Enquiries" value={counts.students} icon={UserPlusIcon} color="#dbac38" bgColor="bg-yellow-100" />
        <InfoCard title="Admissions" value={counts.approvedForms} icon={CheckCircleIcon} color="#16bab1" bgColor="bg-green-100" />
        <InfoCard title="Overall Fee" value={counts.overallFeeAmount} icon={ChartBarIcon} color="#16bab1" bgColor="bg-[#86ddd2]" />
      </div>
     
 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-2">
 <h1 className='  text-gray-500 text-md  text-center border rounded-2xl bg-white p-2 flex flex-col justify-center'>


Fee Management
</h1>
        
        <InfoCard title="Collected Fee" value={counts.totalCollectedFees} icon={CurrencyRupeeIcon} color="green" bgColor="bg-green-100" />
        
        <InfoCard title="Other Fee" value={counts.miscBillTotal} icon={CurrencyRupeeIcon} color="#dbac38" bgColor="bg-yellow-100" />
        <InfoCard title="Total Collected Fees" value={counts.totalPaidWithMisc} icon={CurrencyRupeeIcon} color="#16bab1" bgColor="bg-green-100" />
      </div>
   
 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4  gap-6 mb-2">
 <h1 className='  text-gray-500 text-md  text-center border rounded-2xl bg-white p-2 flex flex-col justify-center'>

          Finance Management
        </h1>
 <InfoCard title="Pending Fee" value={counts.BalanceAmount} icon={CurrencyRupeeIcon} color="dbac38" bgColor="bg-yellow-100" />

 <InfoCard title="Expenses" value={counts.totalExpansiveAmount} icon={ChartBarIcon} color="#f36743" bgColor="bg-[#fa987e]" />
  <InfoCard title="Gross" value={counts.totalPaidWithMisc - counts.totalExpansiveAmount} icon={ChartBarIcon} color="#f36743" bgColor="bg-[#fa987e]" />

  </div>

      {/* Charts Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-5 mb-2">
  
  {/* Admission Management */}
  <div className="bg-white p-6 rounded-2xl shadow-md h-[400px] flex flex-col justify-between">
    <h2 className="text-center text-md  text-gray-500 mb-2">
      Admission Management
    </h2>
    <div className="flex-1 flex justify-center items-center">
      <Bar data={chartData} options={chartOptions} />
    </div>
  </div>

  {/* Fee Management */}
  <div className="bg-white p-6 rounded-2xl shadow-md h-[400px] flex flex-col justify-between">
    <h2 className="text-center  text-md  text-gray-500 mb-2">
      Fee Management
    </h2>
    <div className="flex-1 flex justify-center items-center">
      <Pie data={feeChartData} options={pieOptions} />
    </div>
  </div>

  {/* Finance Management */}
  <div className="bg-white p-6 rounded-2xl shadow-md h-[400px] flex flex-col justify-between">
    <h2 className="text-center   text-md text-gray-500 mb-2">
      Finance Management
    </h2>
    <div className="flex-1 flex justify-center items-center">
      <Pie data={ExpanChartData} options={expanpieOptions} />
    </div>
  </div>

</div>


     

    </div>
  );
};

// Reusable Info Card Component
const InfoCard = ({ title, value, icon: Icon, color, bgColor }) => (
  <div className="bg-white rounded-xl p-1.5 shadow hover:shadow-lg transition">
    <div className="flex items-center  justify-between">
      <div>
        <p className="text-gray-500 text-sm">{title}</p>
        <p className="text-lg font-bold" style={{ color }}>{value}</p>
      </div>
      <div className={`${bgColor} p-3 rounded-full`}>
        <Icon className="w-4 h-4" style={{ color }} />
      </div>
    </div>
  </div>
);

export default Dashboard;
